import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

// Project data — image + elaborated description for each work
const projects = [
  {
    image: "./assets/img/SS_Handrills/American embassy opposite semmozhi part side towards denapet way_02.jpg",
    title: "American Embassy Opposite Semmozhi Park Side Towards Denapet Way",
    description:
      "Vishu Shethra Industries specializes in premium stainless steel handrail work for residential, commercial, and industrial spaces. Located opposite the American Embassy, beside Semmozhi Park, towards Teynampet, we deliver durable, stylish, and customized handrail solutions with superior craftsmanship, quality materials, timely execution, and a strong commitment to customer satisfaction.",
  },
  {
    image: "./assets/img/SS_Handrills/anna arivalayam towards denapet signal_02.jpg",
    title: "Anna Arivalayam Towards Denapet Signal",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, offering durable, stylish, and customized solutions for homes, offices, and commercial spaces. Conveniently located on Anna Arivalayam Road, towards Teynampet Signal, we are committed to quality craftsmanship, timely execution, and complete customer satisfaction with every project.",
  },
  {
    image: "./assets/img/SS_Handrills/DMS bus stand_02.jpg",
    title: "DMS Bus Stand",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, delivering durable, elegant, and customized solutions for residential and commercial projects. Conveniently located near DMS Bus Stand, we are committed to superior craftsmanship, premium materials, timely installation, and complete customer satisfaction in every project we undertake.",
  },
  {
    image: "./assets/img/SS_Handrills/Ekkattuthangal bridge_02.jpg",
    title: "Ekkattuthangal Bridge",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, delivering durable, elegant, and customized solutions for residential and commercial projects. Conveniently located near Ekkattuthangal Bridge, we are committed to superior craftsmanship, premium materials, timely installation, and complete customer satisfaction in every project we undertake.",
  },
  {
    image: "./assets/img/SS_Handrills/Gemini bridge  50th celebration of GNT Road entrance _03.jpg",
    title: "Gemini Bridge 50th Celebration of GNT Road Entrance",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, delivering durable, elegant, and customized solutions for residential and commercial projects. Our work at the Gemini Bridge – 50th Celebration of GNT Road Entrance reflects our commitment to quality craftsmanship, precision engineering, premium materials, and timely project execution.",
  },
  {
    image: "./assets/img/SS_Handrills/kavin art college Poonamallee High Road egmore near_01.jpg",
    title: "Kavin Art College Poonamallee High Road Near Egmore",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, delivering durable, stylish, and customized solutions for residential and commercial projects. Our work near Kavin Art College, Poonamallee High Road, Egmore, showcases our commitment to premium quality, precision craftsmanship, timely execution, and complete customer satisfaction.",
  },
  {
    image: "./assets/img/SS_Handrills/Koyambedu bus terminal new bridge_01.jpg",
    title: "Koyambedu Bus Terminal New Bridge",
    description:
      "Vishu Shethra Industries is a trusted expert in stainless steel handrail work, delivering durable, modern, and customized solutions for residential and commercial projects. Our work at the Koyambedu Bus Terminal New Bridge reflects our dedication to premium quality, precision craftsmanship, reliable installation, and timely project completion with complete customer satisfaction.",
  },
  {
    image: "./assets/img/SS_Handrills/madhya kailash new bridge-Kendra vidhyalaya_04.jpg",
    title: "Madhya Kailash New Bridge Kendra Vidhyalaya",
    description:
      "Vishu Shethra Industries is a trusted name in stainless steel handrail work, providing durable, elegant, and customized solutions for residential and commercial projects. Our work at Madhya Kailash New Bridge, near Kendriya Vidyalaya, showcases our commitment to premium quality, precision craftsmanship, timely execution, and complete customer satisfaction.",
  },
  {
    image: "./assets/img/SS_Handrills/Nandanam  YMCA_01.jpg",
    title: "YMCA Nandanam",
    description:
      "Vishu Shethra Industries is a trusted specialist in stainless steel handrail work, delivering durable, stylish, and customized solutions for residential and commercial projects. Our work at YMCA, Nandanam reflects our commitment to superior craftsmanship, premium materials, precision installation, and timely project completion with complete customer satisfaction.",
  },
  {
    image: "./assets/img/SS_Handrills/omadurar hospital_01.jpg",
    title: "Omadurar Hospital",
    description:
      "Vishu Shethra Industries is a trusted expert in stainless steel handrail work, offering durable, elegant, and customized solutions for residential, commercial, and institutional projects. Our work at Omandurar Government Hospital reflects our commitment to quality craftsmanship, premium materials, precision installation, and timely project execution with complete customer satisfaction.",
  },    
];

const IronSteel = () => {
  const pageTitle =
    "Iron & Steel Projects - VishuShethra Industries | Bridge Fencing & Handrail Works";
  const pageDescription =
    "Explore VishuShethra Industries' iron and steel project portfolio — MS fencing and handrail works completed across Lucas Bridge, Vadapalani Metro, Vandalur, Anna Nagar, and Kanchiwaram bridges.";
  const pageUrl = "https://vishushethra.com/iron-and-steel";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
      </Helmet>

      {/* Banner Section */}
      <div className="banner-section">
        <img
          src="./assets/img/bannerbreadcrumbs.png"
          alt="Banner"
          className="img-fluid banner-img"
        />
        <div className="breadcrumb-container">
          <h2>SS &amp; Fabrication</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                SS &amp; Fabrication
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Intro */}
      <div className="container py-5">
        <h2 className="text-center mb-3">SS Fabrication</h2>
        <p className="text-center text-justify mx-auto" style={{ maxWidth: "800px" }}>
          Take a look at some of our completed SS handrail projects, showcasing our expertise in premium stainless steel fabrication and installation.
        </p>
      </div>

      {/* Projects Grid */}
      <div className="container pb-5">
        <div className="row">
          {projects.map((project, index) => (
            <div className="col-md-6 mb-5" key={index}>
              <div className="card h-100 shadow border-0">
                <img
                  src={project.image}
                  alt={project.title}
                  className="card-img-top"
                  style={{ objectFit: "cover", height: "320px" }}
                />
                <div className="card-body p-4">
                  <h4 className="card-title mb-3">{project.title}</h4>
                  <p className="card-text text-justify">
                    {project.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="VishuShethra Industries"
      />
    </>
  );
};

export default IronSteel;